/* eslint-disable camelcase */
import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { ImageBannerWithContent } from "./ImageBannerWithContent";
import { cloudinaryImageAdapter } from "../../sharedComponents/CloudinaryImageAdapter";

const ImageBannerWithContentConnector = ({ data }) => (
	<ImageBannerWithContent
		contentTitle={data.contentTitle && data.contentTitle}
		contentSubtitle={data.contentSubtitle && data.contentSubtitle}
		contentImagesBlock={
			data.contentImagesBlock && {
				...data.contentImagesBlock,
				cloudinaryImages: data.contentImagesBlock.cloudinaryImages.map(image => ({
					...cloudinaryImageAdapter({
						cloudinaryImage: image?.cloudinaryAsset?.[0],
						maxWidth: 400,
						title: image.title,
						desc: image.title,
					}),
				})),
			}
		}
		contentButton={data.contentButton && data.contentButton}
		fullWidth={data.fullWidth && data.fullWidth}
	/>
);

ImageBannerWithContentConnector.propTypes = {
	data: PropTypes.shape({
		contentTitle: PropTypes.string,
		contentSubtitle: PropTypes.string,
		contentImagesBlock: PropTypes.object.isRequired,
		contentButton: PropTypes.object,
		fullWidth: PropTypes.bool,
	}),
};
ImageBannerWithContentConnector.defaultProps = {
	data: null,
};

export default ImageBannerWithContentConnector;
export { ImageBannerWithContentConnector };
